import styled, {
  css,
} from 'styled-components';

import photo1 from '../../../styles/images/boca-photo-0.jpg';
import photo2 from '../../../styles/images/boca-photo-1.jpeg';
import photo3 from '../../../styles/images/boca-photo-2.jpeg';
import photo4 from '../../../styles/images/boca-photo-3.jpg';
import photo5 from '../../../styles/images/boca-photo-4.jpg';
import photo6 from '../../../styles/images/boca-photo-5.jpg';
import photo7 from '../../../styles/images/boca-photo-6.jpg';
import photo8 from '../../../styles/images/boca-photo-7.jpg';

const photoStyles = css`
  min-height: 445px;
  background-repeat: no-repeat;
  right: 0;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 1200px) {
    min-height: 456px !important;
  }

  @media screen and (max-width: 1035px) {
    min-height: 504px !important;
  }

  @media screen and (max-width: 812px) {
    display: none;
  }
`;

const Photo1 = styled.div`
  ${photoStyles}
  background-image: url(${photo1});
`;

const Photo2 = styled.div`
  ${photoStyles}
  background-image: url(${photo2});
`;

const Photo3 = styled.div`
  ${photoStyles}
  background-image: url(${photo3});
`;

const Photo4 = styled.div`
  ${photoStyles}
  background-image: url(${photo4});
`;

const Photo5 = styled.div`
  ${photoStyles}
  background-image: url(${photo5});
`;

const Photo6 = styled.div`
  ${photoStyles}
  background-image: url(${photo6});
`;

const Photo7 = styled.div`
  ${photoStyles}
  background-image: url(${photo7});
`;

const Photo8 = styled.div`
  ${photoStyles}
  background-image: url(${photo8});
`;

const photos = [
  Photo1,
  Photo2,
  Photo3,
  Photo4,
  Photo5,
  Photo6,
  Photo7,
  Photo8,
];

export default photos;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/photos.js